import { Outlet, useParams } from "react-router-dom";

import { useTournamentStage } from "@/routes/tournament-stage/queries";

export default function TournamentStageLayout() {
    const { tournamentStageId } = useParams<{ tournamentStageId: string }>();

    const { tournamentStage, loading, error, refetch } = useTournamentStage(tournamentStageId);

    if (!tournamentStageId) {
        return null;
    }

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error.message}</p>;
    }

    if (!tournamentStage) {
        return <p>Tournament stage not found</p>;
    }

    return <Outlet context={{ tournamentStage, refetch }} />;
}
